import { combineReducers } from 'redux';
import { loginReducer, userReducer } from '../components/login/redux/reducer';
import investmentReducer from '../components/main/Investments/redux/reducer';
import referralReducer from '../components/main/Referral/redux/reducer';
import annoucementReducer from '../components/main/announcements/redux/reducer';
import constantsReducer from '../components/main/constants/redux/reducer';
import dealPayemntReducer from '../components/main/dealPayment/redux/reducer';
import dealReducer from '../components/main/deals/redux/reducer';
import TeamManagementReducers from '../components/main/onboarding/components/TeamManagement/redux/reducer';
import messageReducer from '../components/message/redux/reducer';

export const rootReducer = combineReducers({
    login: loginReducer,
    user: userReducer,
    message: messageReducer,
    deal: dealReducer,
    investments: investmentReducer,
    dealPayment: dealPayemntReducer,
    announcement: annoucementReducer,
    referral: referralReducer,
    constants: constantsReducer,
    teamManagement:TeamManagementReducers
});

export const getRootReducer = () => rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
